/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import dayjs from 'dayjs';

import { Button, Modal, Table } from '@mairistem/composants';

import type { TracabiliteIndividu } from '@/types';

const LISTE_RECENSEMENT_LABELS = {
  1: 'Recensés',
  2: 'Recensés régularisés',
  3: 'Non recensés',
};

interface ModalHistoriqueRecenseProps {
  nomFamille?: string;
  prenom?: string;
  tracabiliteIndividu?: TracabiliteIndividu[];
  onClose: () => void;
}

const ModalHistoriqueRecense = (props: ModalHistoriqueRecenseProps) => {
  const { nomFamille, prenom, tracabiliteIndividu = [], onClose } = props;

  return (
    <Modal open onClose={onClose} closeIcon>
      <Modal.Header>
        Historique des changements de liste de recensement - {nomFamille}{' '}
        {prenom}
      </Modal.Header>
      <Modal.Content>
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date de recensement</Table.HeaderCell>
              <Table.HeaderCell>Liste de recensement</Table.HeaderCell>
              <Table.HeaderCell>Numéro d&apos;ordre</Table.HeaderCell>
              <Table.HeaderCell>Édité par</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tracabiliteIndividu.length > 0 ? (
              tracabiliteIndividu.map((trace) => (
                <Table.Row key={trace.identifiant}>
                  <Table.Cell>
                    {trace.dateRecensement
                      ? dayjs(trace.dateRecensement).format('DD/MM/YYYY')
                      : '-'}
                  </Table.Cell>
                  <Table.Cell>
                    {LISTE_RECENSEMENT_LABELS[trace.listeRecensement]}
                  </Table.Cell>
                  <Table.Cell>
                    {trace.numeroOrdre === 0
                      ? 'Non numéroté'
                      : trace.numeroOrdre}
                  </Table.Cell>
                  <Table.Cell>
                    {trace.utilisateur
                      ? `${trace.utilisateur.prenom} ${trace.utilisateur.nom}`
                      : '-'}
                  </Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell colSpan="4" textAlign="center">
                  Aucun historique pour ce recensé.
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="Fermer"
          icon="close"
          size="tiny"
          basic
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalHistoriqueRecense;
